import React, { useContext, useEffect, useState } from 'react';
import SlideImageContext from '../contexts/SlideImageContext'

export const SlideImageBackground = () => {
    const { message, config, device, module, ioc, navigation, locale } = useContext(SlideImageContext);

    const { backgroundImage, markedUp, backgroundSize, backgroundRepeat, buttonPosition } = config.configuration;
        
    let embedContent = ioc.injectWithModules(["3r/message-api/content/embedMessageContent"], function(embedMessageContent, text){
        return embedMessageContent(message, {}, text)     
    })

    var divImage = {
        backgroundImage: "url(" + locale.copy(backgroundImage) + ")",
        backgroundSize: backgroundSize ? backgroundSize : '',
        backgroundRepeat: backgroundRepeat ? backgroundRepeat : '',
        display: 'flex',
        flexDirection: buttonPosition === 'before' ? 'column-reverse' : 'column'
    };

    const press = ioc.injectWithModules(["3r/message-api/helpers/press"], function(press, buttonIndex) {
        let button = buttons[buttonIndex]

        return press(
            null,
            function() {
                return navigation.next()
            },
            message,
            button
        )
    })
    
    let buttons = message.quantities.buttons
    buttons.forEach(function(button, i){
        try {
            var translate = false
            var translateText = String(button.value)
            translate = locale.text("ACTION_BUTTON_"+translateText)
            if(translate != false){
                buttons[i].translatedCaption = translate
            }
        } catch(e){
        }
    })


    return (
        <>
            <div className="text-center" style ={divImage}>
                {
                    (markedUp)
                    ?   
                        <p className="text-center" dangerouslySetInnerHTML={{__html: locale.copy(markedUp)}}></p> 
                    : 
                        ""
                }
                
               <div className="text-center" key="buttons">
                    {buttons.map((button, i) => 
                        button.type == 'hyperlink' ? 
                            <a href={button.hyperlink.url} rel="" target={button.hyperlink.target}>
                              <button type="button" class="btn btn-primary" style={{margin: "10px"}} onClick={press.bind(null,i)} key={button.value}>
                                {embedContent(button.translatedCaption ? button.translatedCaption : button.caption)}
                              </button>
                            </a>
                        : <button class="btn btn-primary" onClick={press.bind(null,i)} key={button.value}>
                            {embedContent(button.translatedCaption ? button.translatedCaption : button.caption)}
                        </button>
                    )}
                </div>
            </div>
        </>
    )
}